<script>
    window.location.href = "https://www.ninety.com.br/";
</script>